// React imports.
import React, { Component } from "react";

// App imports.
import Assessment2aMainTable from "./Assessment2aMainTable";
import Assessment2aTopParagraph from "./Assessment2aTopParagraph";
import Assessment2aBottomParagraph from "./Assessment2aBottomParagraph";
import Assessment2aQuestions from "./Assessment2aQuestions";
import Assessment2aDownloadCSV from "./Assessment2aDownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment2aStepsEnum } from "../state";
import { Assessment2aModel } from "../state";


const Assessment2a = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.EnterNumVendors &&
          <div>
              <p><strong><u>Step 1:</u>Enter the Number of Vendors Serving LIHEAP Clients in Your State/Territory</strong></p>

              <p>The first step of Assessment #2A is to establish a baseline number of electric vendors  
              by vendor type in your state/territory.</p>
              <p>All LIHEAP grantees are required to collect electric baseload expenditure data for  
              LIHEAP clients from at least the 5 largest electricity vendors in the state/territory.  
              If your state has fewer than 5 electric vendors, you should try to collect data from  
              all the vendors who serve LIHEAP clients. For example, if your state only has four  
              large electric companies that provide baseload electric service to LIHEAP clients,  
              you should try to collect data from all four of those vendors.</p>
              <p>In some states, baseload electricity is provided by a number of different types  
              of vendors, including investor-owned utility companies, public municipal utilities,  
              and rural electric cooperatives. If possible, it is important to track the type of  
              electric vendors from whom you collect data to ensure that you are not missing data  
              from any particular group. For example, households that use delivered fuels tend  
              to be located in more rural areas and tend to get their electricity from municipal  
              utilities or electric cooperatives. Therefore, if you are not collecting electric  
              data from any municipal utilities or co-ops, then you might be missing important  
              data for your fuel oil or propane households.</p>
              <p><strong>In the table below, please enter the number of Investor-Owned Utilities,  
              Public Municipal Utilities, and Rural Electric Cooperatives that serve LIHEAP  
              clients in your state/territory. If you are aware of an electric vendor that  
              serves LIHEAP clients but unsure of its type, count that utility in the Unknown  
              row. </strong>  This information is NOT reported in your annual Performance  
              Measures Form, so you will need to provide it from your own records.</p>
              <br/>
              <Assessment2aMainTable model={state.Assessment2aModelInstance} fieldChangeHandler={state.assessment2aFieldChangeHandler} step={state.Assessment2aSteps[state.CurrentAssessementStepIndex]} />
              <TableLegendLeft />
          </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.EnterVendorsReq &&
          <div>
              <p><strong><u>Step 2:</u>Enter the Number of Vendors from Whom Data was Requested</strong></p>
              The next step of Assessment #2A is to check if you requested data from the minimum required number of electric vendors. The number of vendors for whom data was requested is NOT reported in your annual Performance Measures Form, so you will need to provide this information from your own records
              <br/><br/>
              In the table below, enter the number vendors from whom your office requested electric baseload expenditure data. As a reminder, a vendor can be defined as a company, utility, or cooperative that provides LIHEAP clients with their electric baseload fuel.
              <br/>
              <Assessment2aMainTable model={state.Assessment2aModelInstance} fieldChangeHandler={state.assessment2aFieldChangeHandler} step={state.Assessment2aSteps[state.CurrentAssessementStepIndex]} />
              <TableLegendLeft />
          </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.EnterVendorsRec &&
          <div>
              <p><strong><u>Step 3:</u>Enter the Number of Vendors from Whom Data was Received</strong></p>
              The third step of Assessment #2 is to check if you actually received data from the minimum number of electric vendors. The number of vendors from whom data was received is NOT reported in your annual Performance Measures Form, so you will need to provide this information from your own records.
              <br/><br/>
              In the table below, enter the number vendors from whom your office received electric baseload expenditure data. We are continuing to define a vendor as a company, utility, or cooperative that provides LIHEAP clients with their electric baseload fuel.
              <br/>
              <Assessment2aMainTable model={state.Assessment2aModelInstance} fieldChangeHandler={state.assessment2aFieldChangeHandler} step={state.Assessment2aSteps[state.CurrentAssessementStepIndex]} />
              <TableLegendLeft />
          </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.Results &&
          <div>
              <p><strong><u>Step 4:</u>  Results - Total Number of Vendors Requested/Received</strong></p>
              
              <Assessment2aTopParagraph model={state.Assessment2aModelInstance}  />
              <br/>
              <Assessment2aMainTable model={state.Assessment2aModelInstance} fieldChangeHandler={state.assessment2aFieldChangeHandler} step={state.Assessment2aSteps[state.CurrentAssessementStepIndex]} />
              <TableLegendLeft />
              <Assessment2aBottomParagraph model={state.Assessment2aModelInstance} state={state}/>
              <Assessment2aQuestions model={state.Assessment2aModelInstance} state={state}/>
          </div>
          }
          <br/>

          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.ZeroVendorForType &&
          <div>
              <p><strong><u>Step 5:</u>   Results - Vendor Type</strong></p>
              Your data collection efforts for electric baseload expenditures have been flagged because
              your state/territory has  {state.Assessment2aModelInstance.totalZeroVendorString}  that
              serve LIHEAP clients but you did
              NOT request information from any of them. You may have not requested information from
              any municipal electric utilities or rural co-ops because they are not one of the top 5
              electric vendors, but if a significant portion of your households are served by these
              vendor types, failing to request information from any of these vendors increases the
              probability that the sample you have collected is not adequately representative of
              the entire state/territory.
              <Assessment2aMainTable model={state.Assessment2aModelInstance} fieldChangeHandler={state.assessment2aFieldChangeHandler} step={state.Assessment2aSteps[state.CurrentAssessementStepIndex]} />
              <TableLegendLeft />
              You are not obligated to request information from electric vendors of any particular 
              type but requesting data from vendors of all types will improve the quality of your data.

              {(state.Assessment2aModelInstance.investorOwnedUtilVendorsNum > 0
                  && state.Assessment2aModelInstance.investorOwnedUtilRequestedVendorsNum === 0)
              &&
              <div>
                  Please indicate your plans for requesting data from investor owned utilities in the response
                  box below. If you do not plan to request from extra vendors, you may indicate that as well.   
                  <textarea  name="investorOwnedUtilplanRequestDataDesc"
                    id="investorOwnedUtilplanRequestDataDesc" style={{width:"100%"}}
                    value={state.Assessment2aModelInstance.investorOwnedUtilplanRequestDataDesc}
                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, state.Assessment2aModelInstance)}></textarea>
              </div>
              }
              {(state.Assessment2aModelInstance.publicMuniUtilVendorsNum > 0
                  && state.Assessment2aModelInstance.publicMuniUtilRequestedVendorsNum === 0)
              &&
              <div>
                  Please indicate your plans for requesting data from public municipal utilities in the response
                  box below. If you do not plan to request from extra vendors, you may indicate that as well.   
                  <textarea  name="publicMuniplanRequestDataDesc"
                    id="publicMuniplanRequestDataDesc" style={{width:"100%"}}
                    value={state.Assessment2aModelInstance.publicMuniplanRequestDataDesc}
                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, state.Assessment2aModelInstance)}></textarea>
              </div>
              }
              {(state.Assessment2aModelInstance.ruralCoopVendorsNum > 0
                  && state.Assessment2aModelInstance.ruralCoopRequestedVendorsNum === 0)
              &&
              <div>
                  Please indicate your plans for requesting data from electric cooperative utilities in the response
                  box below. If you do not plan to request from extra vendors, you may indicate that as well.   
                  <textarea  name="ruralCoopplanRequestDataDesc"
                    id="ruralCoopplanRequestDataDesc" style={{width:"100%"}}
                    value={state.Assessment2aModelInstance.ruralCoopplanRequestDataDesc}
                    onChange={(changeEvent) => state.assessment2aFieldChangeHandler(changeEvent, state.Assessment2aModelInstance)}></textarea>
              </div>
              }
          </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.ActionPlanSummary &&
          <div>
              <p>
                  <strong><u>Step 6:</u> Aggregated Action Plan </strong>
              </p>
              <p>
                  Congratulations! You have reached the end of Assessment #2a. Your
                  aggregated action plan for every issue identified in Assessment
                  #2a is included in the table below. You can now download or print
                  the Assessment #2a action plan below. Also, you can revisit this
                  page at any time by selecting it from the list of completed
                  assessments on the Assessment Tool Selection Page.
              </p>
              <p>
                  Now that you have completed Assessment #2A, we strongly recommend
                  that you continue on to Assessment #2B. To this, simply click the
                  "Finish &amp; Save" button and you will be returned to the Assessment
                  Selection page. From there you can begin Assessment #2B.
              </p>  
              <table id="tblDataReliabilityActionPlan">
                  <thead>
                    <tr>
                        <th>Issue</th>
                        <th>Action Plan</th>
                    </tr>
                  </thead>
                  <tbody>
                      {!(state.showActionPlan(state.Assessment2aModelInstance))
                      &&
                      <tr>
                          <td colSpan={2}>N/A</td>
                      </tr>}

                      {(state.showActionPlan(state.Assessment2aModelInstance))
                      &&
                      <React.Fragment>
                          {(state.Assessment2aModelInstance.requestDataMinVendorsDesc	!== '' && state.Assessment2aModelInstance.requestDataMinVendorsDesc	!== null)
                          &&
                          <tr>
                            <td>You must request data from the required number of electric vendors. Since there are at least five electricity vendors in your state who serve LIHEAP clients, this means you must request and receive data from at least five electric vendors. Please indicate your plans to address this issue in the box below.	</td>
                            <td>{state.Assessment2aModelInstance.requestDataMinVendorsDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.vendorAgreementsHaveDataCollectionReqDesc	!== '' && state.Assessment2aModelInstance.vendorAgreementsHaveDataCollectionReqDesc	!== null)
                          &&
                          <tr>
                            <td>Do your vendor agreements with electric vendors include data collection requirements?	</td>
                            <td>{state.Assessment2aModelInstance.vendorAgreementsHaveDataCollectionReqDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.clientWaiversMeetVendorRequirementsDesc	!== '' && state.Assessment2aModelInstance.clientWaiversMeetVendorRequirementsDesc	!== null)
                          &&
                          <tr>
                            <td>Do your client waivers satisfy electric vendors’ privacy standards for sharing client data?	</td>
                            <td>{state.Assessment2aModelInstance.clientWaiversMeetVendorRequirementsDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.vendorsAlertedTimelyMannerDesc	!== '' && state.Assessment2aModelInstance.vendorsAlertedTimelyMannerDesc	!== null)
                          &&
                          <tr>
                            <td>Do you send data requests out to your vendors as soon as possible after the end of the Federal Fiscal Year in order to give them ample time to respond before the reporting deadline? 	</td>
                            <td>{state.Assessment2aModelInstance.vendorsAlertedTimelyMannerDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.deliveredFuelSmallElectricVendorDesc	!== '' && state.Assessment2aModelInstance.deliveredFuelSmallElectricVendorDesc	!== null)
                          &&
                          <tr>
                            <td>Need to know if more than half of your delivered fuel (Fuel Oil and Propane) households receive their baseload electric service from a small electric vendor that is not in your top 5.	</td>
                            <td>{state.Assessment2aModelInstance.deliveredFuelSmallElectricVendorDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.smallElectricVendorCollectDataDesc	!== '' && state.Assessment2aModelInstance.smallElectricVendorCollectDataDesc	!== null)
                          &&
                          <tr>
                            <td>Plan to collect data from small electric vendors.	</td>
                            <td>{state.Assessment2aModelInstance.smallElectricVendorCollectDataDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.otherReasonDesc	!== '' && state.Assessment2aModelInstance.otherReasonDesc	!== null)
                          &&
                          <tr>
                            <td>Plans to remedy data collection issues.	</td>
                            <td>{state.Assessment2aModelInstance.otherReasonDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.publicMuniplanRequestDataDesc	!== '' && state.Assessment2aModelInstance.publicMuniplanRequestDataDesc	!== null)
                          &&
                          <tr>
                            <td>Please indicate your plans for requesting data from public municipal utilities.	</td>
                            <td>{state.Assessment2aModelInstance.publicMuniplanRequestDataDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.ruralCoopplanRequestDataDesc	!== '' && state.Assessment2aModelInstance.ruralCoopplanRequestDataDesc	!== null)
                          &&
                          <tr>
                            <td>Please indicate your plans for requesting data from electric cooperatives.	</td>
                            <td>{state.Assessment2aModelInstance.ruralCoopplanRequestDataDesc	}</td>
                          </tr>}
                          {(state.Assessment2aModelInstance.investorOwnedUtilplanRequestDataDesc	!== '' && state.Assessment2aModelInstance.investorOwnedUtilplanRequestDataDesc	!== null)
                          &&
                          <tr>
                            <td>Please indicate your plans for requesting data from investor owned utilities.	</td>
                            <td>{state.Assessment2aModelInstance.investorOwnedUtilplanRequestDataDesc	}</td>
                          </tr>}
                      </React.Fragment>
                      }
                  </tbody>
              </table>
          </div>
          }

          <br />
          <button className="dataButton"
              onClick={() => state.assessment2aShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment2aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2aShowNextStep()}
                  disabled={state.Assessment2aShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment2aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2aShowActionPlan()}
                  disabled={state.Assessment2aShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment2aStepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment2aStepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment2aStepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment2aStepsEnum.ActionPlanSummary
          &&
            <Assessment2aDownloadCSV model={state.Assessment2aModelInstance} />
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment2a;
